import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  action?: { label: string; to: string };
  dark?: boolean;
  className?: string;
}

export function SectionHeader({
  eyebrow,
  title,
  subtitle,
  action,
  dark,
  className,
}: SectionHeaderProps) {
  return (
    <div className={cn('flex flex-wrap items-end justify-between gap-4', className)}>
      <div>
        {eyebrow && (
          <p
            className={cn(
              'text-xs font-semibold uppercase tracking-wide',
              dark ? 'text-brand-300' : 'text-brand-600',
            )}
          >
            {eyebrow}
          </p>
        )}
        <h2
          className={cn(
            'font-display text-2xl font-bold tracking-tight sm:text-3xl',
            dark ? 'text-white' : 'text-surface-950',
            eyebrow && 'mt-1',
          )}
        >
          {title}
        </h2>
        {subtitle && (
          <p className={cn('mt-2 max-w-xl text-sm', dark ? 'text-white/55' : 'text-surface-600')}>
            {subtitle}
          </p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className={cn(
            'inline-flex items-center gap-1 text-sm font-semibold',
            dark ? 'text-brand-300 hover:text-brand-200' : 'text-brand-700 hover:text-brand-800',
          )}
        >
          {action.label}
          <ArrowRight className="h-4 w-4" />
        </Link>
      )}
    </div>
  );
}
